module.exports = __webpack_public_path__ + "img/part-two-1.d9141c31.png";